import React from "react";
import { Button } from "antd";
import dayjs from "dayjs";
import { toast } from "react-toastify";

import { round2 } from "../../utils/tools";

const formatTxtForXML = (txt) => {
  if (txt.length > 35) {
    txt = txt.substring(0, 35);
  }

  return txt
    .replace(/@/g, "A")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

const Sepa = ({ journal, lignesReddition, raisonSociale }) => {
  const handleDownload = () => {
    if (lignesReddition.length === 0) {
      toast.error("Sélectionne au moins un relevé pour générer le fichier SEPA.", {
        containerId: "A",
      });
      return;
    }

    const ligneMontantInvalide = lignesReddition.find((ligne) => {
      const montant = round2(ligne.montantDu);

      return !Number.isFinite(montant) || montant < 0.01 || montant > 999999999.99;
    });

    if (ligneMontantInvalide) {
      toast.error(
        `Montant SEPA invalide pour ${ligneMontantInvalide.proprietaire_nom} (${round2(
          ligneMontantInvalide.montantDu
        )} €).`,
        { containerId: "A" }
      );
      return;
    }

    const ligneSansIban = lignesReddition.find(
      (ligne) =>
        !ligne.proprietaire?.personne_compte_bancaire?.compte_bancaire_IBAN
    );

    if (ligneSansIban) {
      toast.error(`IBAN manquant pour ${ligneSansIban.proprietaire_nom} !`, {
        containerId: "A",
      });
      return;
    }

    const SEPA = require("sepa");

    const doc = new SEPA.Document("pain.001.001.03");
    doc._xmlEncoding = "UTF-8";
    doc.grpHdr.id = "01";
    doc.grpHdr.created = new Date();
    doc.grpHdr.initiatorName = formatTxtForXML(
      journal.journal_compte_bancaire.compte_bancaire_titulaire
    );

    const info = doc.createPaymentInfo();
    info.requestedExecutionDate = new Date();
    info.debtorIBAN = journal.journal_compte_bancaire.compte_bancaire_IBAN
      .split(" ")
      .join("");
    info.debtorBIC = journal.journal_compte_bancaire.compte_bancaire_BIC;
    info.debtorName = formatTxtForXML(
      journal.journal_compte_bancaire.compte_bancaire_titulaire
    );
    info.debtorId = "01";
    doc.addPaymentInfo(info);

    lignesReddition.forEach((ligne) => {
      const compteBancaire = ligne.proprietaire.personne_compte_bancaire;
      const tx = info.createTransaction();
      tx.creditorName = formatTxtForXML(ligne.proprietaire_nom);
      tx.creditorIBAN = compteBancaire.compte_bancaire_IBAN.split(" ").join("");
      tx.creditorBIC = compteBancaire.compte_bancaire_BIC;
      tx.mandateId = `${ligne.proprietaire_id}`;
      tx.mandateSignatureDate = new Date();
      tx.amount = round2(ligne.montantDu);
      tx.remittanceInfo = `${formatTxtForXML(
        raisonSociale
      )} Virt Releve de gestion du ${dayjs().format("DD/MM/YYYY")}`;
      tx.end2endId = formatTxtForXML(compteBancaire.compte_bancaire_titulaire);
      info.addTransaction(tx);
    });

    const sepa = doc.toString().replace('encoding="null"', 'encoding="UTF-8"');
    const name = `sepa-du-${dayjs().format("DD/MM/YYYY-HH:mm")}.xml`;
    const element = document.createElement("a");
    const file = new Blob([sepa], { type: "text/xml;charset=utf-8" });

    element.href = URL.createObjectURL(file);
    element.download = name;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <Button onClick={handleDownload}>SEPA</Button>
  );
};

export default Sepa;
